module.exports = {"TXTWCL_Competitions":{"id":"TXTWCL_Competitions","defaultMessage":"Turneringer"}}